var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#0DD1C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.417 11.056a.548.548 0 01-.358-.144L4.55 8.332a.563.563 0 010-.789.563.563 0 01.788 0l2.08 2.15 4.372-4.587a.562.562 0 01.789 0 .562.562 0 010 .788l-4.732 5.018c-.143.072-.286.144-.43.144z",
    fill: "#0DD1C5"
  })));
}
export default SvgStatisticCheckboxChecked;